import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ConsoleShell } from "#/widgets/console-shell";

export const Route = createFileRoute("/_console")({
  component: ConsoleLayout,
});

function ConsoleLayout() {
  return (
    <ConsoleShell>
      <Outlet />
    </ConsoleShell>
  );
}
